export const daysOfWeek = {
    sunday: 0, 
    monday: 1, 
    tuesday: 2, 
    wednesday: 3, 
    thursday: 4, 
    friday: 5, 
    saturday: 6
};

export const getNextDayOfWeek = (date, dayOfWeek) => {
    date = date || new Date();

    var resultDate = new Date(date.getTime());
    const dayOffset = ((7 + dayOfWeek - date.getDay()) % 7);

    resultDate.setDate(date.getDate() + dayOffset);

    return resultDate;
};

export const getNextSunday = date => getNextDayOfWeek(date, daysOfWeek.sunday);
export const getNextMonday = date => getNextDayOfWeek(date, daysOfWeek.monday);
export const getNextTuesday = date => getNextDayOfWeek(date, daysOfWeek.tuesday);
export const getNextWednesday = date => getNextDayOfWeek(date, daysOfWeek.wednesday);
export const getNextThursday = date => getNextDayOfWeek(date, daysOfWeek.thursday);
export const getNextFriday = date => getNextDayOfWeek(date, daysOfWeek.friday);
export const getNextSaturday = date => getNextDayOfWeek(date, daysOfWeek.saturday);